module.exports = __webpack_public_path__ + "static/Overhead-a07abfcb90db1276c71dcdd71f311686.jpg";